///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-security.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-point-promotions.collection.ts"/>
///<reference path="../common/data-template-base.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportPointPromotionsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected pointPromotions: ReportPointPromotionsCollection;

        public title: string;
        public allSelectedLabel: string;
        public required: boolean;

        get collection() {
            return this.pointPromotions;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options);

            this.pointPromotions = new ReportPointPromotionsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue || SmartMoverHiddenValue.EmptyArray,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.filters = [new PointPromotionsFilter([this.pointPromotions], { criteria: options.criteria }, this)];
            this.title = 'LABEL_POINT_PROMOTIONS';
            this.allSelectedLabel = 'LABEL_ALL_POINT_PROMOTIONS';
            this.totalSelectedMessage = 'LABEL_TOTAL_POINT_PROMOTIONS_SELECTED';
        }

        setWatchers(scope: ng.IScope): void {
            scope.$watch(() => this.pointPromotions.responseList, (newValue: any) => {
                if (this.required && newValue.length > 0 && this.validation.length === 0) {
                    this.validation.push(
                        new RequiredValidation(this.pointPromotions)
                    );
                }
            });
            super.setWatchers(scope);
        }
    }
}
